import './index-57001be3.js';
import { L as LOCALE } from './Locale-e37edea6.js';

var RISK_SCREENER_NAME;
(function (RISK_SCREENER_NAME) {
    RISK_SCREENER_NAME["HPV"] = "hpv";
})(RISK_SCREENER_NAME || (RISK_SCREENER_NAME = {}));
const RISK_SCREENER_SLUG = {
    [LOCALE.Vietnam]: {
        [RISK_SCREENER_NAME.HPV]: 'hpv-vaccine',
    },
    [LOCALE.Indonesia]: {
        [RISK_SCREENER_NAME.HPV]: 'deteksi-dini-hpv',
    },
};

export { RISK_SCREENER_NAME, RISK_SCREENER_SLUG };
